// extracted by mini-css-extract-plugin
export var buttonContent = "_30-0";
export var centered = "_30-1";
export var centeredFlex = "_30-2";
export var errorText = "_30-3";
export var icon = "_30-4";
export var iconButtonContent = "_30-5";
export var monospace = "_30-6";
export var padded = "_30-7";